import React, {useState} from 'react';
import {Trans} from 'react-i18next';
import _get from 'lodash/get';
import DataTable from '../../../../../components/datatable/DataTable';
import ElevatedButton from '../../../../../components/formik/ElevatedButton';
import {handleTemplateExport} from '../../../../../utils/skincareUtils';
import OverLayLoader from '../../../../../components/spinner/OverLayLoader';

export default function SameConsent({
  isLoading = true,
  formikProps,
  categories,
  isTechnicalSupport,
}) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (templateId, templateName) => {
    const sanitizedName = templateName
      .replace(/[^a-z0-9]/gi, '_')
      .toLowerCase();
    await handleTemplateExport({
      templateId,
      fileName: `UserConsent_${sanitizedName}`,
      setIsExporting,
    });
  };

  const columns = [
    {
      Header: (
        <Trans i18nKey="p.s.uiconfiguration.customized.ui.selected">
          Selected
        </Trans>
      ),
      accessor: 'value',
      disableSortBy: true,
      style: {width: '5%', textAlign: 'center'},
      Cell: ({
        cell: {
          row: {original},
        },
      }) => (
        <div className="text-center">
          <input
            type="radio"
            value={original.value}
            onChange={e => {
              _get(formikProps, 'values.user_consents', []);
              formikProps.setFieldValue('user_consents', [
                {
                  template_id: original.value,
                  store_ids: [],
                },
              ]);
            }}
            checked={
              _get(formikProps, 'values.user_consents[0].template_id') ===
              original.value
            }
          />
        </div>
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.c.customization.template.name">Template Name</Trans>
      ),
      accessor: 'label',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
    },
    ...(isTechnicalSupport
      ? [
          {
            Header: <Trans i18nKey="p.s.c.customization.file">File</Trans>,
            accessor: 'file',
            disableSortBy: true,
            style: {width: '5%', textAlign: 'center'},
            Cell: ({
              cell: {
                row: {original},
              },
            }) => (
              <div className="text-center">
                {original.value === -1 ? (
                  <span>-</span>
                ) : (
                  <ElevatedButton
                    type="custom"
                    faIcon="fa-download"
                    text={
                      <Trans i18nKey="p.s.c.customization.export.html.file">
                        Export HTML File
                      </Trans>
                    }
                    onClick={() => handleExport(original.value, original.label)}
                    disabled={isExporting}
                  />
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={_get(categories, 'tempCategory', [])}
        initState={{
          pageSize: 5,
        }}
        loading={isLoading}
      />
      {isExporting && (
        <OverLayLoader
          text={
            <Trans i18nKey="c.spinner.overlay.loader.exporting">
              Exporting...
            </Trans>
          }
        />
      )}
    </div>
  );
}
